<script>
export const group = 'Bottom'
</script>

<script setup>
import { cdnImageUrl } from '@dpgradio/creative'
import CharacterJumpFromTheRight from './text_animations/CharacterJumpFromTheRight.vue'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'
import AnimatedSkewedEllipsMaskWithEnergeticFrequencies from './shared/AnimatedSkewedEllipsMaskWithEnergeticFrequencies.vue'
import { frames } from '../../../utils/frames'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const timelineTitle = ref(null)
const timelineLineA = ref(null)
const timelineLineB = ref(null)
const timelineImage = ref(null)

const contentElement = ref(null)
const thumbnailElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'NextPlayingSmall' }).add(timelineTitle).add(timelineImage, '<').add(timelineLineA, '<.44').add(timelineLineB, '<.24')
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timelineTitle.value.reverse()
  timelineLineA.value.reverse()
  timelineLineB.value.reverse()

  return await gsapTimeline({ name: 'NextPlayingSmall - End' })
    .add(timelineTitle)
    .add(timelineLineB, '<.08')
    .add(timelineLineA, '<.24')
    .to(thumbnailElement, { scale: 0, duration: frames(5), ease: 'power2.in' }, '<')
    .endInvisible(contentElement, '>0.25')
})
</script>

<template>
  <div class="h-full w-full">
    <div ref="contentElement" class="absolute bottom-0 p-safe flex items-end space-x-1">
      <AnimatedSkewedEllipsMaskWithEnergeticFrequencies v-if="item.enrichment.track.next?.thumbnail" ref="thumbnailElement" class="-mb-10" @timeline="timelineImage = $event">
        <img :src="cdnImageUrl(item.enrichment.track.next?.thumbnail)" class="w-full h-full object-cover" />
      </AnimatedSkewedEllipsMaskWithEnergeticFrequencies>
      <div class="relative -space-y-3">
        <CharacterJumpFromTheRight text="Zometeen" class="text-q-cr-red-primary" @timeline="timelineTitle = $event" />
        <CharacterEnlarge :text="item.enrichment.track.next?.title" class="text-white font-cervo font-bold text-[85px]" @timeline="timelineLineA = $event" />
        <CharacterEnlarge :text="item.enrichment.track.next?.artist.name" class="text-white font-cervo text-[85px]" @timeline="timelineLineB = $event" />
      </div>
    </div>
  </div>
</template>
